import { render, staticRenderFns } from "./newModule.vue?vue&type=template&id=7e2aedbe"
import script from "./newModule.vue?vue&type=script&lang=js"
export * from "./newModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports